export default __webpack_public_path__ + "static/media/three.2fbc22ae.svg";